import { removeProtectionLink } from './removeProtection.locstring.json';
import loc from 'owa-localize';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import setIRMData from '../../actions/rms/setIRMData';
import {
    InfoBarCustomAction,
    InfoBarHostViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import ProtectionViewState from 'owa-mail-protection-types/lib/schema/ProtectionViewState';

export default function getRemoveProtectionInfobarMessage(
    infoBarViewState: InfoBarHostViewState,
    protectionViewState: ProtectionViewState,
    templateId: string
): InfoBarCustomAction {
    return {
        text: loc(removeProtectionLink),
        action: () => {
            removeInfoBarMessage(infoBarViewState, templateId);
            setIRMData(protectionViewState, null);
        },
    };
}
